import ko from 'rgs-knockout';
import _ from "lodash";
import vb from 'validation-builder';

import { serverTime } from 'observable-server-time';
import { observableDocumentType } from 'observable-document-type';
import { Document } from "calc-common";
import { JPIDENTITYDOCUMENT } from 'known-jp-identity-document-types';

class JuridicalPersonIdentityDocument extends Document {

	constructor (options) {
		super(options);

		this._jpIdentityDocumentTypes = options.dictionaries.jpIdentityDocumentTypes;

		this.documentName = ko.pureComputed(() => (
			this.Type() ? this._jpIdentityDocumentTypes.get(this.Type()).Name : null
		));

		this.documentsShortOptionsList = ko.pureComputed(() => (
			_.filter(this._jpIdentityDocumentTypes.values(), x => x.IsPopular)
		));

		this.documentsFullOptionsList = ko.pureComputed(() => (
			this._jpIdentityDocumentTypes.values()
		));

		this.isDocumentExpandoListRedundant = ko.pureComputed(() => {
			const shortListCount = this.documentsShortOptionsList().length;
			const fullListCount = this.documentsFullOptionsList().length;

			const isPoorChoiceList = fullListCount <= 4;
			const isPoorListDiff = (fullListCount - shortListCount) <= 2;

			return isPoorChoiceList && isPoorListDiff;
		});

		this.Type = observableDocumentType(JPIDENTITYDOCUMENT.CertificateOfStateRegistration)
			.extend({ toFromJS: true })
			.extend({ validation: vb.required() });

		this.Series = this.Series
			.extend({
				validation: vb.all([
					vb.required(),
					vb.digitsOnly(),
					vb.notOnlyZero(),
					vb.length(2),
					/*
					vb.if(() => this.Type.isCertificateOfStateRegistration(), vb.all([
					])),
					vb.if(() => this.Type.isCertificateOfRegistrationIntoTaxAuthority(), vb.all([
					])),
					*/
				]),
			});
		
		this.Number = this.Number
			.extend({
				validation: vb.all([
					vb.required(),
					vb.digitsOnly(),
					vb.notOnlyZero(),
					vb.length(9),
					/*
					vb.if(() => this.Type.isCertificateOfStateRegistration(), vb.all([
					])),
					vb.if(() => this.Type.isCertificateOfRegistrationIntoTaxAuthority(), vb.all([
					])),
					*/
				]),
			});

		this.IssueDate = ko.observable()
			.extend({
				toFromJS: true,
				validation: vb.all([
					vb.momentIsValid(),
					vb.momentIsSameOrBefore(() => serverTime().toISOString()),
				]),
			});
	}
}
export { Document, JuridicalPersonIdentityDocument };
